import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

// Wraps the public portfolio pages. Kept as a layout route so standalone
// pages (e.g. /assistant) can render without the navbar or its offset.
const PortfolioLayout = () => {
  return (
    <div className="App">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default PortfolioLayout;
